import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { slugify } from '../../utils/slugify';
import './ProjectDetails.scss';

function ProjectDetails() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch('/projects.json')
      .then(res => res.json())
      .then(data => {
        const found = data.find(p => slugify(p.title) === id);
        setTimeout(() => {
          setProject(found);
          setLoading(false);
        }, 600);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="project-details__loading">
        <span className="project-details__spinner"></span>
        <span className="project-details__loading-text">Carregando projeto...</span>
      </div>
    );
  }

  return (
    <div className="project-details">
      <div className="project-details__wrapper">
        <div className="project-details__image-box">
          <img src={`/${project.image}`} alt={project.title} className="project-details__image" />
        </div>
        {project.gallery ? (
          <div className="project-details__gallery-layout">
            <div className="project-details__gallery-info">
              <div className="project-details__info">
                <h1 className="project-details__title">{project.title}</h1>
                <div className="project-details__subtitle">{project.subtitle}</div>
              </div>
              {project.customBottom && (
                <div className="project-details__indicators project-details__indicators--gallery">
                  <div className="project-details__indicator-group">
                    {project.customBottom.map((item, idx) => (
                      <div className="project-details__indicator" key={idx}>
                        <div className="project-details__indicator-value">+{item.value}</div>
                        <div className="project-details__indicator-label">{item.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {project.tags && project.tags.length > 0 && (
                <div className="project-details__tags">
                  {project.tags.map((tag, idx) => (
                    <span className="project-details__tag" key={idx}>{tag}</span>
                  ))}
                </div>
              )}
            </div>
            <div className="project-details__gallery-desc">
              {project.description.split('\n').map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        ) : (
          <div className="project-details__info-desc">
            <div className="project-details__info">
              <h1 className="project-details__title">{project.title}</h1>
              <div className="project-details__subtitle">{project.subtitle}</div>
            </div>
            <div className="project-details__desc">
              {project.description.split('\n').map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="project-details__footer-bar" style={{ width: '100%' }}>
        {Array.from({ length: 30 }).map((_, i) => (
          <span key={i} style={{ display: 'inline', whiteSpace: 'pre' }}>
            {'// # $ % @ \' = ) ) ) ] [ [ / / \' \' \' = - " - " ~ ^ ; . < > { { { }} '}
          </span>
        ))}
      </div>
      {/* Indicadores dinâmicos */}
      {!project.gallery && project.customBottom && (
        <div className="project-details__indicators">
          <div className="project-details__indicator-group">
            {project.customBottom.map((item, idx) => (
              <div className="project-details__indicator" key={idx}>
                <div className="project-details__indicator-value">+{item.value}</div>
                <div className="project-details__indicator-label">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Formulário de Patrocínio */}
      <div className="project-details__sponsor-form">
        <div className="project-details__sponsor-info">
          <h2>Patrocine esse projeto</h2>
          <p>Sua empresa pode fazer parte dessa transformação!<br />
            Ao patrocinar o projeto, você impulsiona a educação, gera impacto social e contribui para um futuro mais inclusivo.<br /><br />
            Vamos construir esse futuro juntos?
          </p>
        </div>
        <form className="project-details__form" onSubmit={e => e.preventDefault()}>
          <input type="text" placeholder="NOME COMPLETO" className="project-details__input" />
          <input type="email" placeholder="E-MAIL" className="project-details__input" />
          <textarea placeholder="MENSAGEM" className="project-details__textarea" rows={4}></textarea>
          <button type="submit" className="project-details__button">ENVIAR</button>
        </form>
      </div>

    </div>
  );
}

export default ProjectDetails;
